import { useAtom } from 'jotai';
import { experienceCategoryAtom, experienceCategoryTabAtom } from '../atoms/modal.atom';
import { useCallback } from 'react';

export function useExperienceCategory() {
  const [category, setCategory] = useAtom(experienceCategoryAtom);
  const [tab, setTab] = useAtom(experienceCategoryTabAtom);
  const closeModal = useCallback(() => setCategory(null), [setCategory]);
  return { category, setCategory, closeModal, tab, setTab };
}
